    <div class="componente-importantes text-start px-5 mt-3" style="min-height:700px ;" >
        <form
          action=""
          method="post"
          (submit)="formSubmit()"
          [formGroup]="Step1form"
          class="needs-validation"
        >
        <section class="row  ">
            <div class="col-12 col-lg-6 col-xxl-4 d-flex justify-content-center justify-content-lg-start">
                <div>
                    <label for="formControlInput" class="form-label mt-5  ">Nombre</label>
                    <input required placeholder="Ingrese información" formControlName="name" type="text" class="custom-outline-input mt-3" id="">
                    <div class="invalid-feedback">
                        Llene el campo Nombre.
                       </div>
                </div>
            </div>
            <div class="col-12 col-lg-6 col-xxl-4 d-flex justify-content-center justify-content-lg-start">
                <div>
                    <label for="formControlInput" class="form-label mt-5 ">Alias</label>
                    <input required type="text" placeholder="Ingrese información" formControlName="project_alias" class="custom-outline-input mt-3" id="formControlInput">
                    <div class="invalid-feedback">
                        Llene el campo Alias.
                       </div>
                </div> 
            </div>
            <div class="col-12 col-lg-6 col-xxl-4 d-flex justify-content-center justify-content-lg-start">
                <div>
                    <label for="formControlInput" class="form-label mt-5 ">Tipo de proyecto</label>
                    <select required class="custom-outline-input form-select mt-3"  formControlName="project_type">
                    <option selected class="text-white" value="" > Seleccione...</option>
                    <option *ngFor="let item of listType" [value]="item.id"> {{item.name}}</option>
                    </select>
                    <div class="invalid-feedback">
                        Seleccione un Tipo de proyecto.
                       </div>
                </div>
                
            </div>
            <div class="col-12 col-lg-6 col-xxl-4 d-flex justify-content-center justify-content-lg-start">
                <div>
                    <label for="formControlInput" class="form-label mt-5">Clientes</label>
                    <select required class="custom-outline-input form-select mt-3 " (change)="index($event)" formControlName="customers_id" aria-label="Default select">
                        <option selected value="" > Seleccione...</option>
                        <option *ngFor="let item of listClient; index as i"  [value]="item.id"> {{item.name}}</option>
                    </select>
                    <div class="invalid-feedback">
                        Seleccione Clientes.
                       </div>
                </div>
                
            </div>
            <div class="col-12 col-lg-6 col-xxl-4 d-flex justify-content-center justify-content-lg-start">
                <div>
                    <label for="formControlInput" class="form-label mt-5">Frente</label>
                    <select required class="custom-outline-input form-select mt-3" (change)="indexEnd($event)"  formControlName="fronts_id" aria-label="Default select">
                        <option selected value="" > Seleccione...</option>
                        <option *ngFor="let item of listFrente" [value]="item.id"> {{item.name}}</option>
                    </select>
                    <div class="invalid-feedback">
                        Seleccione Frente.
                       </div>
                </div>
            </div>
            <div class="col-12 col-lg-6 col-xxl-4 d-flex justify-content-center justify-content-lg-start">
                <div>
                    <label for="formControlInput" class="form-label mt-5">Sucursales</label>
                    <select required class="custom-outline-input form-select mt-3" formControlName="headquarters_id" aria-label="Default select">
                        <option selected value="">Seleccione...</option>
                        <option *ngFor="let item of listHeadquarter" [value]="item.id"> {{item.name}}</option>
                    </select>
                    <div class="invalid-feedback">
                        Seleccione Sucursales.
                       </div>
                </div>
                
            </div>
            <div class="col-12 col-lg-6 col-xxl-4 d-flex justify-content-center justify-content-lg-start">
                <div>
                    <label for="formControlInput" class="form-label mt-5">Tecnologias</label>
                    <input placeholder="Ingrese información" type="text" formControlName="technologies"  class="custom-outline-input mt-3" id="formControlInput">
                    <div class="invalid-feedback">
                        Llene el campo Tecnologias.
                       </div>
                </div>
            </div>
            <div class="col-12 col-lg-6 col-xxl-4 d-flex justify-content-center justify-content-lg-start">
                <div>
                    <label for="formControlInput" class="form-label mt-5">N casos de uso</label>
                    <input placeholder="Ingrese información" type="text" formControlName="estimated_cu" class="custom-outline-input mt-3" id="formControlInput">
                    <div class="invalid-feedback">
                        Llene el campo N casos de uso.
                       </div>
                </div>
            </div>
            <div class="col-12 col-lg-6 col-xxl-4 d-flex justify-content-center justify-content-lg-start">
                <div>
                    <label for="formControlInput" class="form-label mt-5">HH estimadas</label>
                    <input placeholder="Ingrese información" type="text" formControlName="hh" class="custom-outline-input mt-3" id="formControlInput">
                    <div class="invalid-feedback">
                        Llene el campo HH estimadas.
                       </div>
                </div>   
            </div>

            <div class="col-12 col-lg-6 col-xxl-4 d-flex justify-content-center justify-content-lg-start">

                <div>
                    <label for="formControlInput" class="form-label mt-5">Origen Comercial</label>
                    <select required class="custom-outline-input form-select mt-3 " formControlName="commercial_origin" aria-label="Default select">
                        <option selected value="" > Seleccione...</option>
                        <option *ngFor="let item of listPais; index as i"  [value]="item.description"> {{item.description}}</option>
                    </select>
                    <div class="invalid-feedback">
                        Seleccione Origen Comercial.
                       </div>
                </div>


                <!-- <div>
                    <label for="formControlInput" class="form-label mt-5">Origen Comercial</label>
                    <input required placeholder="Ingrese información" type="text" formControlName="commercial_origin"  class="custom-outline-input mt-3" id="formControlInput">
                    <div class="invalid-feedback">
                        Llene el campo Origen Comercial.
                       </div>
                </div> -->
            </div>

            <div class="col-12 col-lg-6 col-xxl-4 d-flex justify-content-center justify-content-lg-start">

                <div>
                    <label for="formControlInput" class="form-label mt-5">Operación</label>
                    <select required class="custom-outline-input form-select mt-3 " formControlName="operation" aria-label="Default select">
                        <option selected value="" > Seleccione...</option>
                        <option *ngFor="let item of listPais; index as i"  [value]="item.description"> {{item.description}}</option>
                    </select>
                    <div class="invalid-feedback">
                        Seleccione Operación.
                       </div>
                </div>

                <!-- <div>
                    <label for="formControlInput" class="form-label mt-5">Operación</label>
                    <input required placeholder="Ingrese información" type="text" formControlName="operation"  class="custom-outline-input mt-3" id="formControlInput">
                    <div class="invalid-feedback">
                        Llene el campo Operación.
                       </div>
                </div> -->
            </div> 

            <!-- <ng-container *ngIf="permise == true">
                <div class="col-12 col-lg-6 col-xxl-4 d-flex justify-content-center justify-content-lg-start">
                    <div>
                        <label for="formControlInput" class="form-label mt-5 ">Tipo de moneda</label>
                        <select required class="custom-outline-input form-select mt-3"  (change)="actionSelectType()" formControlName="play_option_id" >
                        <option selected value="" > Seleccione...</option>
                        <option *ngFor="let item of listmonedas" [value]="item.id" >{{item.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-12 col-lg-6 col-xxl-4 d-flex justify-content-center justify-content-lg-start">
                    <div>
                        <label for="formControlInput" class="form-label mt-5 ">Monto inicial</label>
                        <input required type="text" placeholder="Ingrese información" formControlName="monto_init" class="custom-outline-input mt-3" id="formControlInput"  (blur)="transformAmount($event)">
                    </div> 
            </div>
            </ng-container> -->

            <!-- <ng-container *ngIf="permise == false">
                <div class="col-12 col-lg-6 col-xxl-4 justify-content-center justify-content-lg-start">
                  <div>
                    <label for="tipoMoneda" class="form-label mt-5">Tipo de moneda</label>
                    <span class="form-control custom-outline-input mt-3">{{type_select}}</span>
                  </div>
                </div>
                <div class="col-12 col-lg-6 col-xxl-4  justify-content-center justify-content-lg-start">
                  <div>
                    <label for="montoInicial" class="form-label mt-5">Monto inicial</label>
                    <span class="form-control custom-outline-input mt-3">{{ Step1form.get('monto_init')?.value }}</span>
                  </div> 
                </div>
              </ng-container> -->


            <div class="col-12 col-lg-6 col-xxl-4 d-flex justify-content-center justify-content-lg-start"></div>
            <div class="col-12 d-flex justify-content-center justify-content-lg-start">
                <div>
                    <label for="formControlInput" class="form-label mt-5">Detalles</label>
                    <textarea required class="custom-outline-input mt-3" formControlName="description" placeholder="Dejar detalles aqui..." id="floatingTextarea" style="height:100px !important;" ></textarea>
                    <div class="invalid-feedback">
                        Llene el campo Detalles.
                       </div>
                </div>
            </div>
        </section>
        <!-- 2/3 -->
        
           
       
        
        <section class="row ">
           
        </section>
        <!-- 3/3 -->
        <section class="row">
           
        </section>

        <footer class="row mt-5 pb-3">
            <div class="col-12 d-flex justify-content-end">
                <button [disabled]="!Step1form.valid" type="submit" class="mx-2 btn btn-outline-light"> <i class="fa fa-floppy-disk m-1" aria-hidden="true"></i>  Guardar</button>
            </div>
        </footer>
        </form>
    </div>